import React from 'react';
import { ROLES_MODULE, Select } from '../../../../components';
import styled from 'styled-components';

export type CreateUserRoleDialogProps = {
  netId?: string;
  role?: string[];
  setAddRole: (role: ROLES_MODULE) => void;
};

export const CreateUserRoleDialog: React.FC<
  CreateUserRoleDialogProps
> = props => {
  const { netId, role, setAddRole } = props;

  const selections = Object.keys(ROLES_MODULE)
    .map(key => {
      return {
        label: key,
        value: ROLES_MODULE[key as keyof typeof ROLES_MODULE],
      };
    })
    .filter(item => item.value !== ROLES_MODULE.NA)
    .filter(item => !role?.includes(item.value));

  return (
    <AddRoleModelStyle>
      <div className="modal-row">
        <div className="w-24">User</div>
        <div>{netId}</div>
      </div>
      <div className="modal-row">
        <div className="w-24">Add Role</div>
        <div className="w-[160px]">
          <Select
            options={selections}
            fullWidth
            onChange={e => {
              setAddRole(e.target.value as ROLES_MODULE);
            }}
          />
        </div>
      </div>
    </AddRoleModelStyle>
  );
};

const AddRoleModelStyle = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 2rem 1rem;

  .modal-row {
    display: flex;
    flex-direction: row;
    height: 3rem;
    align-items: center;
    padding: 0 1rem;
  }
`;
